module.exports = __webpack_public_path__ + "img/314.1145579b.png";